<template>
  <div>
    <HMModalHeader
      :title="$t('SETTINGS.TITLE.SIGNERS')"
      @close="$emit('close')"
    ></HMModalHeader>
    <h2>{{ waiver.title }}</h2>
    <HMSearch v-model="search" />
    <div v-if="isLoading" class="w-100 text-center py-4">
      <HMSpinner />
    </div>
    <HMTable
      v-else
      class="mt-3 mb-4"
      :items="filteredSigners"
      :fields="waiverSignersFields"
    >
      <template slot="full_name" slot-scope="{ data }">
        <router-link
          :to="`/customers/${data.student.id}`"
          class="d-block"
          @click="$emit('close')"
        >
          {{ data.student.full_name }}
        </router-link>
      </template>
      <template slot="email" slot-scope="{ data }">
        {{ data.student.email }}
      </template>
      <template slot="ip_address" slot-scope="{ data }">
        {{ data.ip_address }}
      </template>
      <template slot="signature_date" slot-scope="{ data }">
        <span>{{ $formatDate(data.created, 'date-time') }}</span>
      </template>
    </HMTable>
  </div>
</template>

<script>
import { errorToMessage } from '../../../../core/utils/errors';

export default {
  name: 'WaiverSignersModal',
  props: {
    waiver: {
      type: Object,
    },
  },
  computed: {
    filteredSigners() {
      return this.waiverSigners.filter(signer => {
        return (
          signer.student.full_name
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          signer.student.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
  },
  data() {
    return {
      search: '',
      isLoading: true,
      waiverSigners: [],
      waiverSignersFields: [
        {
          name: 'full_name',
          title: this.$t('CUSTOMERS.TABLE.NAME'),
        },
        {
          name: 'email',
          title: this.$t('CUSTOMERS.TABLE.EMAIL'),
        },
        {
          name: 'ip_address',
          title: this.$t('CUSTOMERS.TABLE.SIGNATURE_IP'),
        },
        {
          name: 'signature_date',
          title: this.$t('CUSTOMERS.TABLE.SIGNATURE_DATE'),
        },
      ],
    };
  },
  async mounted() {
    try {
      this.waiverSigners = await this.$store.dispatch(
        'setting/getWaiverSigners',
        this.waiver.id
      );
    } catch (error) {
      this.$notify({
        type: 'error',
        title: 'Failed to load waiver signers',
        text: errorToMessage(error?.response, `Request failed: ${error}`),
      });
      this.$emit('close');
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped></style>
